import React from 'react';

export default function StarRating({ rating, count, size = 14 }) {
  const stars = [1, 2, 3, 4, 5];
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3 }}>
      {stars.map(s => (
        <svg key={s} width={size} height={size} viewBox="0 0 24 24"
          fill={s <= Math.round(rating) ? '#f59e0b' : 'none'}
          stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
        >
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
        </svg>
      ))}
      {rating > 0 && (
        <span style={{ fontSize: size - 2, color: 'var(--gray-400)', marginLeft: 2 }}>
          {rating.toFixed(1)}{count != null ? ` (${count})` : ''}
        </span>
      )}
      {rating === 0 && (
        <span style={{ fontSize: size - 2, color: 'var(--gray-500)', marginLeft: 2 }}>No ratings yet</span>
      )}
    </span>
  );
}
